import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { IGroup } from '../../../data/models/Entities';

@customElement('app-group-avatar')
export class GroupAvatar extends LitElement {
    static styles = css`
        :host { display:inline-block; }
        .avatar {
            width: 100px;
            height: 100px;
            border-radius: 16px;
            display:flex;
            align-items:center;
            justify-content:center;
            font-weight:700;
            color:var(--avatar-fg, #fff);
            background: var(--avatar-bg, #6c5ce7);
        }
        app-avatar {
            box-shadow: 0 6px 18px rgba(15,23,42,0.08);
            cursor:pointer;
            user-select:none;
            border: 5px solid var(--color, #e0e0e0);
            transition: transform 220ms cubic-bezier(.2,.9,.2,1), box-shadow 220ms ease;
            transform-origin: center center;
            display: block;
        }

        .wrap { position: relative; display:inline-block; }
        .wrap:hover app-avatar {
            transform: translateY(-6px) scale(1.04);
            box-shadow: 0 18px 40px rgba(15,23,42,0.14);
        }

        app-badge {
            position: absolute;
            top: 6px;
            right: 6px;
        }

        h4 { margin: 8px 0 0; font-size: 0.9rem; text-align:center }
    `;

    @property({ type: Object }) group: IGroup | null = null;

    render() {
        const g = this.group;
        if (!g) return html``;
        const color = g.EsPrincipal ? 'var(--color-g-primario)' : 'var(--color-g-secundario)';
        const badge = g.NMessages && g.NMessages > 0 ? g.NMessages : null;

        this.style.setProperty('--color', color);

        return html`
            <div class="wrap">
                <app-avatar
                    .k_width=${"calc(var(--padding2) * 7 + 45px)"}
                    .k_height=${"calc(var(--padding2) * 7 + 45px)"}
                    .k_alt=${g.NombreGrupo}
                    k_variant="rounded"
                ></app-avatar>
                ${badge ? html`<app-badge .k_value=${badge}></app-badge>` : ''}
            </div>
            <h4 title="${g.NombreGrupo}">${g.NombreGrupo}</h4>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'app-group-avatar': GroupAvatar;
    }
}